import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import { STATUS_LABELS } from '../../config/const.config';

const Status = ({
  id,
  name,
  defaultValue,
  label,
  onChange,
  validOptions,
  sx,
  error,
}) => (
  <FormControl fullWidth error={error !== ''}>
    <InputLabel id={`field-${id}-select-label`}>{label}</InputLabel>
    <Select
      labelId="demo-simple-select-label"
      id={id}
      name={name}
      value={defaultValue}
      label={label}
      onChange={onChange}
      sx={sx}
    >
      {validOptions.map((k) => (
        <MenuItem key={`${id}-v-${k}`} value={k}>
          {STATUS_LABELS[k]}
        </MenuItem>
      ))}
    </Select>
    {error !== '' && <FormHelperText>{error}</FormHelperText>}
  </FormControl>
);

Status.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  validOptions: PropTypes.array.isRequired,
  sx: PropTypes.shape(),
  error: PropTypes.string,
};
Status.defaultProps = {
  sx: {},
  error: '',
};

export default Status;
